export default {
    "Join broadcast": "Rejoindre l'évènement",
}
